import React, { useState } from 'react';
import css from './FlipAndWinCards.css';
import { Alert, SecondaryButton } from '../../../../components';
import OfferInfoModal from '../../sectionsSuperDeals/SectionSuperDeals/OfferInfoModal';
import { IconCheckmark, IconEyeL } from '../../../../icons';
import { useRequest } from '../../../../hooks/useRequest';
import { useDispatch } from 'react-redux';
import { insertNotificationModalData } from '../../../../ducks/UI.duck';
import { getCreditsNotificationData } from '../../../../credits-config';
import { getFlipAndWinCredits } from '../../../../util/api';
import { isCreditsCard, isProductCard } from './helpers';
import { fetchCurrentUser } from '../../../../ducks/user.duck';

export default ({ card, currentUser }) => {
    const { id: cardId, withParams } = card;

    const dispatch = useDispatch();
    const [modalOpen, setModalOpen] = useState(false);
    const { error, loading, request } = useRequest();

    const {
        id: { uuid },
        attributes: {
            profile: {
                firstName,
                lastName,
                publicData: { city, postalCode, houseNumber, streetAddress },
            },
        },
    } = currentUser;

    const { flipAndWinData = {} } = currentUser?.attributes?.profile?.privateData || {};
    const { cardsFlipped, newFlipAllowedAt } = flipAndWinData || { cardsFlipped: {} };
    const { actionAllowed } = cardsFlipped[cardId];

    const disableButton = isCreditsCard(card) && !actionAllowed;

    const getButtonWinText = card => (isCreditsCard(card) ? 'Einlösen' : 'Ansehen');
    const getButtonWinIcon = card => (isCreditsCard(card) ? <IconCheckmark /> : <IconEyeL />);

    const closeModal = () => {
        if (!loading) setModalOpen(false);
    };

    const initCreditsEvent = () =>
        request(
            async () => await getFlipAndWinCredits(cardId),
            eventData => {
                closeModal();
                dispatch(insertNotificationModalData(getCreditsNotificationData(eventData)));
                dispatch(fetchCurrentUser());
            },
            closeModal
        );

    const handlePostFlipAction = () => {
        if (!isCreditsCard(card)) {
            return setModalOpen(true);
        }

        if (!disableButton && isCreditsCard(card)) {
            return initCreditsEvent();
        }
    };

    if (error) {
        return <Alert showAsPlainText type="failure" description={error} closeAllowed={false} />;
    }

    return (
        <>
            <SecondaryButton type="button" onClick={handlePostFlipAction} disabled={disableButton}>
                {getButtonWinIcon(card)} {getButtonWinText(card)}
            </SecondaryButton>
            {modalOpen && (
                <OfferInfoModal
                    isOpen
                    isLoggedOut={false}
                    onClose={closeModal}
                    {...card}
                    voucherType={isProductCard(card) ? 'link' : ''}
                    voucherCode={card.voucherCode || card.voucherLink}
                    logoClassName={css.logo}
                    endDate={{ date: newFlipAllowedAt }}
                    queryParams={
                        withParams
                            ? {
                                  vorname: firstName,
                                  nachname: lastName,
                                  strasse: streetAddress,
                                  nummer: houseNumber,
                                  postleitzahl: postalCode,
                                  ort: city,
                                  uid: uuid,
                              }
                            : null
                    }
                />
            )}
        </>
    );
};
